import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";

function JobTitleAutoSuggestField({intl, settings, ...rest}) {
  const {additionalData, currentStep, setFormData, formData} = useContext(FormContext);
  settings.noResultsMessage = 'Autosuggest.Noresults.Message';

  if (!additionalData['qualifications']) {
    return '';
  }

  const formatValue = (value) => {
    return (value) ? value.replace(/\s{2,}/g, ' ').trim() : '';
  }

  let jobTypeOptions = [];
  let jobTypesFiltered = [];
  let jobTypesFilteredOptions = [];

  if (additionalData['qualifications']) {
    jobTypeOptions = Object.values(additionalData['qualifications']).map(function(object) {
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const match = formatValue(object.Value).toLowerCase().indexOf(formatValue(formValue).toLowerCase()) !== -1;

        if (match) {
          jobTypesFilteredOptions.push(formatValue(object.Value));
          jobTypesFiltered.push({
            Key: object.Key,
            Value: formatValue(object.Value)
          });
        }
      } else {
        return object;
      }
      return '';
    })
  }

  if (jobTypesFilteredOptions.length > 0) {
    settings.options = jobTypesFilteredOptions;
  } else {
    jobTypeOptions = [];
    settings.options = jobTypeOptions;
  }

  rest.onChange = e => {

    const {value} = e.target;
    const match = jobTypesFiltered.find(el => el.Value === value);

    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
        }
        prev[currentStep][settings.name] = match.Value;
        prev[currentStep][settings.idFieldName] = match.Key;
        return {
          ...prev
        }
      });
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep][settings.idFieldName] = null;
        return {
          ...prev
        }
      });
    }
  };

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
}

export default injectIntl(JobTitleAutoSuggestField);
